import { action, makeObservable, observable } from 'mobx';
import { isObject, scopedWarningMessage } from '@philips-internal/oswald-ui-utils';
/* EDITOR SECTIONS */
export const TOPBAR = 'topbar';
export const SPOTLIGHT = 'spotlight';
export const PREFERENCES = 'preferences';
/* SCOPES */
export const GLOBAL = 'global';
export const FRAGMENT = 'fragment';
class ConfigStore {
    constructor() {
        Object.defineProperty(this, "map", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
    }
    add(...items) {
        for (const item of items.filter(isObject)) {
            if (!item.id) {
                scopedWarningMessage('editor', `Missing id. The item won't be added.`);
                continue;
            }
            if (this.map.has(item.id)) {
                scopedWarningMessage('editor', `Duplicate id: '${item.id}'. The item will be overwritten.`);
            }
            this.map.set(item.id, item);
        }
    }
    get(id) {
        return this.map.get(id);
    }
    delete(id) {
        this.map.delete(id);
    }
    has(id) {
        return this.map.has(id);
    }
    items() {
        return Array.from(this.map.values());
    }
}
class DialogStore extends ConfigStore {
    constructor() {
        super();
        Object.defineProperty(this, "closeListeners", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, "current", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "props", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        makeObservable(this, {
            close: action.bound,
            current: observable,
            open: action.bound,
            props: observable,
        });
    }
    open(id, props = {}) {
        this.current = id;
        this.props.set(id, props);
    }
    close(data) {
        for (const listener of this.closeListeners) {
            listener(this.current, data);
        }
        this.current = '';
    }
    addCloseListener(listener) {
        if (this.closeListeners.has(listener)) {
            throw Error('Listener already added.');
        }
        this.closeListeners.add(listener);
        return () => this.closeListeners.delete(listener);
    }
    getCurrent() {
        return this.current;
    }
    getProps(id) {
        if (this.props.has(id)) {
            return this.props.get(id) || {};
        }
        return {};
    }
    isAnyOpened() {
        return this.current !== '';
    }
    isOpened(id) {
        return this.current === id;
    }
}
class EditorAPI {
    constructor() {
        Object.defineProperty(this, "actions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new ConfigStore()
        });
        Object.defineProperty(this, "dialogs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new DialogStore()
        });
        Object.defineProperty(this, "preferences", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new ConfigStore()
        });
        Object.defineProperty(this, "properties", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new ConfigStore()
        });
    }
}
export default new EditorAPI();
export { ConfigStore, DialogStore, EditorAPI, };
//# sourceMappingURL=editor-api.js.map